import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

import { useLocalStorage } from "../../hooks/useLocalStorage";

const AdminMenu = () => {
  const navigate = useNavigate();

  const [_school] = useLocalStorage("Auth", "school", null);

  useEffect(() => {});

  const isMeetingEnabled = (school) =>
    _school != null && _school.meetingEnabled === "Y";
  const isScoreEnabled = (school) =>
    school != null && school.scoreEnabled === "Y";
  const isActivitiesEnabled = (school) =>
    school != null && school.activitiesEnabled === "Y";
  const isCheckinEnabled = (school) =>
    school != null && school.checkinEnabled === "Y";
  const isCourseEnabled = (school) =>
    school != null && school.courseEnabled === "Y";
  const isPassEnabled = (school) =>
    school != null && school.passEnabled === "Y";
  const isEventEnabled = (school) =>
    school != null && school.eventEnabled === "Y";
  const isCommunityServiceEnabled = (school) =>
    school != null && school.communityServiceEnabled === "Y";

  return (
    <Paper sx={{ mt: 1 }}>
      <MenuList>
        <MenuItem sx={{ pt: 0, pb: 0 }}>
          <Typography variant="body1" className="menuHeader">
            MAIN
          </Typography>
        </MenuItem>
        <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          <Link
            sx={{ ml: 0.5 }}
            onClick={() => navigate("/admin/welcome")}
            className="menuLink"
          >
            Admin Home
          </Link>
        </MenuItem>
        <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          <Link
            sx={{ ml: 0.5 }}
            onClick={() => navigate("/adm/request")}
            className="menuLink"
          >
            Requests/Issues
          </Link>
        </MenuItem>
        <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          <Link
            sx={{ ml: 0.5 }}
            onClick={() => navigate("/teacher/welcome")}
            className="menuLink"
          >
            Teacher Home
          </Link>
        </MenuItem>
        {/* <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          <Link
            sx={{ ml: 0.5 }}
            onClick={() => navigate("/student/welcome")}
            className="menuLink"
          >
            Student Home
          </Link>
        </MenuItem> */}

        <Divider />
        <MenuItem sx={{ pt: 0, pb: 0 }}>
          <Typography variant="body1" className="menuHeader">
            REPORTS
          </Typography>
        </MenuItem>

        <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          <Link
            sx={{ ml: 0.5 }}
            onClick={() => navigate("/faculty/reports")}
            className="menuLink"
          >
            All Reports
          </Link>
        </MenuItem>
        <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          <Link
            sx={{ ml: 0.5 }}
            onClick={() => navigate("/report/watchdog")}
            className="menuLink"
          >
            Watchdog
          </Link>
        </MenuItem>

        {isActivitiesEnabled(_school) && (
          <>
            <Divider />
            <MenuItem sx={{ pt: 0, pb: 0 }} className="menuHeader">
              ACTIVITIES
            </MenuItem>
            <MenuItem sx={{ pt: 0, pb: 0.0 }}>
              <Link
                sx={{ ml: 0.5}}
                onClick={() => navigate("/adm/activity")}
                className="menuLink"
              >
                Activity Settings
              </Link>
            </MenuItem>{" "}
            <MenuItem sx={{ pt: 0, pb: 0.0 }}>
              <Link
                sx={{ ml: 0.5 }}
                onClick={() => navigate("/adm/locked-students")}
                className="menuLink"
              >
                Locked Students
              </Link>
            </MenuItem>
          </>
        )}

        {isPassEnabled(_school) && (
          <>
            <Divider />
            <MenuItem sx={{ pt: 0, pb: 0 }}>
              <Typography variant="body1" className="menuHeader">
                PASSES
              </Typography>
            </MenuItem>
            <MenuItem sx={{ pt: 0, pb: 0.0 }}>
              <Link
                sx={{ ml: 0.5 }}
                onClick={() => navigate("/adm/manage-passes")}
                className="menuLink"
              >
                Manage Passes
              </Link>
            </MenuItem>
            <MenuItem sx={{ pt: 0, pb: 0.0 }}>
              <Link
                sx={{ ml: 0.5 }}
                onClick={() => navigate("/adm/pass")}
                className="menuLink"
              >
                Pass Settings
              </Link>
            </MenuItem>
          </>
        )}

        <Divider />
        <MenuItem sx={{ pt: 0, pb: 0 }}>
          <Typography variant="body1" className="menuHeader">
            USERS
          </Typography>
        </MenuItem>
        <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          <Link
            sx={{ ml: 0.5 }}
            onClick={() => navigate("/adm/absentees")}
            className="menuLink"
          >
            Absentees
          </Link>
        </MenuItem>
        <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          <Link
            sx={{ ml: 0.5 }}
            onClick={() => navigate("/adm/student")}
            className="menuLink"
          >
            Students
          </Link>
        </MenuItem>
        <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          <Link
            sx={{ ml: 0.5 }}
            onClick={() => navigate("/adm/teacher")}
            className="menuLink"
          >
            Teachers
          </Link>
        </MenuItem>
        <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          <Link
            sx={{ ml: 0.5 }}
            onClick={() => navigate("/adm/admin")}
            className="menuLink"
          >
            Admins
          </Link>
        </MenuItem>

        <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          <Link
            sx={{ ml: 0.5 }}
            onClick={() => navigate("/adm/homeroom")}
            className="menuLink"
          >
            Homerooms
          </Link>
        </MenuItem>

        {isCheckinEnabled(_school) === true && (
          <>
            <Divider />
            <MenuItem sx={{ pt: 0, pb: 0 }}>
              <Typography variant="body1" className="menuHeader">
                CHECKIN
              </Typography>
            </MenuItem>
            <MenuItem sx={{ pt: 0, pb: 0.0 }}>
              <Link
                sx={{ ml: 0.5 }}
                onClick={() => navigate("/adm/checkin/comment-history")}
                className="menuLink"
              >
                Comment History
              </Link>
            </MenuItem>
            <MenuItem sx={{ pt: 0, pb: 0.0 }}>
              <Link
                sx={{ ml: 0.5 }}
                onClick={() => navigate("/adm/checkin/weekly-hours")}
                className="menuLink"
              >
                Weekly Hours
              </Link>
            </MenuItem>
            <MenuItem sx={{ pt: 0, pb: 0.0 }}>
              <Link
                sx={{ ml: 0.5 }}
                onClick={() => navigate("/adm/checkin/monthly-hours")}
                className="menuLink"
              >
                Monthly Hours
              </Link>
            </MenuItem>
            <MenuItem sx={{ pt: 0, pb: 0.0 }}>
              <Link
                sx={{ ml: 0.5 }}
                onClick={() => navigate("/adm/checkin/override-hours")}
                className="menuLink"
              >
                Override Hours
              </Link>
            </MenuItem>
            <MenuItem sx={{ pt: 0, pb: 0.0 }}>
              <Link
                sx={{ ml: 0.5 }}
                onClick={() => navigate("/adm/checkin/settings")}
                className="menuLink"
              >
                Checkin Settings
              </Link>
            </MenuItem>
            <MenuItem sx={{ pt: 0, pb: 0.0 }}>
              <Link
                sx={{ ml: 0.5 }}
                onClick={() => navigate("/adm/bulk-add-score")}
                className="menuLink"
              >
                Bulk Add Scores
              </Link>
            </MenuItem>
          </>
        )}

        <Divider />
        <MenuItem sx={{ pt: 0, pb: 0 }}>
          <Typography variant="body1" className="menuHeader">
            SCHOOL
          </Typography>
        </MenuItem>

        {isScoreEnabled(_school) && (
          <MenuItem sx={{ pt: 0, pb: 0.0 }}>
            <Link
              sx={{ ml: 0.5 }}
              onClick={() => navigate("/adm/score")}
              className="menuLink"
            >
              Score Settings
            </Link>
          </MenuItem>
        )}

        <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          <Link
            sx={{ ml: 0.5 }}
            onClick={() => navigate("/adm/school")}
            className="menuLink"
          >
            School Settings
          </Link>
        </MenuItem>

        {isMeetingEnabled(_school) && (
          <MenuItem sx={{ pt: 0, pb: 0.0 }}>
            <Link
              sx={{ ml: 0.5 }}
              onClick={() => navigate("/adm/meeting")}
              className="menuLink"
            >
              Meetings
            </Link>
          </MenuItem>
        )}

        {isEventEnabled(_school) && (
          <MenuItem sx={{ pt: 0, pb: 0.0 }}>
            <Link
              sx={{ ml: 0.5 }}
              onClick={() => navigate("/adm/event")}
              className="menuLink"
            >
              Event Settings
            </Link>
          </MenuItem>
        )}

        {isCommunityServiceEnabled(_school) && (
          <MenuItem sx={{ pt: 0, pb: 0.0 }}>
            <Link
              sx={{ ml: 0.5 }}
              onClick={() => navigate("/adm/comm-service")}
              className="menuLink"
            >
              Community Service
            </Link>
          </MenuItem>
        )}

        {isCourseEnabled(_school) && (
          <MenuItem sx={{ pt: 0, pb: 0.0 }}>
            <Link
              sx={{ ml: 0.5 }}
              onClick={() => navigate("/adm/course/teacher-courses")}
              className="menuLink"
            >
              Course Settings
            </Link>
          </MenuItem>
        )}

        {/* <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          
            <Link
              sx={{ ml: 0.5 }}
              onClick={() => navigate("/adm/email")}
              className="menuLink"
            >
              Emails
            </Link>
         
        </MenuItem> */}

        <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          <Link
            sx={{ ml: 0.5 }}
            onClick={() => navigate("/adm/announcement")}
            className="menuLink"
          >
            Announcements
          </Link>
        </MenuItem>
        <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          <Link
            sx={{ ml: 0.5 }}
            onClick={() => navigate("/adm/data/export")}
            className="menuLink"
          >
            Data Export
          </Link>
        </MenuItem>
        <MenuItem sx={{ pt: 0, pb: 0.0 }}>
          <Link
            sx={{ ml: 0.5 }}
            onClick={() => navigate("/report/teacher-homeroom-report")}
            className="menuLink"
          >
            Teacher Homerooms
          </Link>
        </MenuItem>

      </MenuList>
    </Paper>
  );
};

export default AdminMenu;
